var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127.917,
    height: 127.917,
    viewBox: "0 0 127.917 127.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellisse_14",
    x: 0,
    y: 0,
    width: 127.917,
    height: 127.917,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_vocal_off",
    transform: "translate(15.213 15.174)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15.21, -15.17)",
    filter: "url(#Ellisse_14)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_14-2",
    "data-name": "Ellisse 14",
    cx: 48.959,
    cy: 48.959,
    r: 48.959,
    transform: "translate(15 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2566",
    "data-name": "Raggruppa 2566",
    transform: "translate(33.314 21.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_1672",
    "data-name": "Rettangolo 1672",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#707283",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.998,
    height: 44.997,
    rx: 14.999,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28.998,
    height: 43.997,
    rx: 14.499,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3334",
    "data-name": "Tracciato 3334",
    d: "M1471,208v7.519",
    transform: "translate(-1456.001 -163.003)",
    fill: "none",
    stroke: "#707283",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3335",
    "data-name": "Tracciato 3335",
    d: "M1465,212.01h22.5",
    transform: "translate(-1461.25 -159.495)",
    fill: "none",
    stroke: "#707283",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3336",
    "data-name": "Tracciato 3336",
    d: "M1463.59,196h27.8",
    transform: "translate(-1462.483 -167.877)",
    fill: "none",
    stroke: "#707283",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2565",
    "data-name": "Raggruppa 2565",
    transform: "translate(7.499 7.499)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_15",
    "data-name": "Ellisse 15",
    cx: 1.875,
    cy: 1.875,
    r: 1.875,
    transform: "translate(5.625)",
    fill: "#707283"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_16",
    "data-name": "Ellisse 16",
    cx: 1.875,
    cy: 1.875,
    r: 1.875,
    transform: "translate(11.249)",
    fill: "#707283"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_17",
    "data-name": "Ellisse 17",
    cx: 1.875,
    cy: 1.875,
    r: 1.875,
    fill: "#707283"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_18",
    "data-name": "Ellisse 18",
    cx: 1.875,
    cy: 1.875,
    r: 1.875,
    transform: "translate(5.625 5.625)",
    fill: "#707283"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_19",
    "data-name": "Ellisse 19",
    cx: 1.875,
    cy: 1.875,
    r: 1.875,
    transform: "translate(11.249 5.625)",
    fill: "#707283"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_20",
    "data-name": "Ellisse 20",
    cx: 1.875,
    cy: 1.875,
    r: 1.875,
    transform: "translate(0 5.625)",
    fill: "#707283"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_21",
    "data-name": "Ellisse 21",
    cx: 1.875,
    cy: 1.875,
    r: 1.875,
    transform: "translate(5.625 11.249)",
    fill: "#707283"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_22",
    "data-name": "Ellisse 22",
    cx: 1.875,
    cy: 1.875,
    r: 1.875,
    transform: "translate(11.249 11.249)",
    fill: "#707283"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_23",
    "data-name": "Ellisse 23",
    cx: 1.875,
    cy: 1.875,
    r: 1.875,
    transform: "translate(0 11.249)",
    fill: "#707283"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic_icon.624173f0302fcd891ca15c69c252f2cb.svg";
export { ForwardRef as ReactComponent };